module.exports = __webpack_public_path__ + "static/itsm_capabilities_5-8f7532c6e864f44de27c2fc6458ea28f.png";